import axios from "axios";
import {getStoredRefreshToken,setRefreshToken, getToken, setToken} from '@/utils/auth'
import { tansParams } from "@/utils/ruoyi";
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import errorCode from '@/utils/errorCode'
import cache from '@/plugins/cache'
import router from "@/router";


// 是否显示重新登录
export let isRelogin = { show: false };

const refreshToken = async () => {
  // axios.defaults.headers.common['tenant-id'] = getTenantId()

  // return await axios.post(process.env.VUE_APP_BASE_API + '/system/auth/refresh-token?refreshToken=' + getToken())

  return await axios.post(
    '/admin-api/system/auth/refresh-token?refreshToken=' + encodeURIComponent(getStoredRefreshToken()),
    null,  // 如果没有请求体，可以传 `null`
    {
      headers: {
        'tenant-id': '1'  // 在请求头中添加 tenant-id
      }
    }
  )
}

// 封装axios
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 设置axios的基础URL
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;


// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 10000,
})

const tenantId = 1

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  config.headers['tenant-id'] = tenantId
  config.headers['X-TimeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // 添加自定义请求头
  // config.headers['tag'] = 'LAPTOP-457MV4FV'

  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
      return config;
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url;                  // 请求地址
      const s_data = sessionObj.data;                // 请求数据
      const s_time = sessionObj.time;                // 请求时间
      const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        const message = '数据正在处理，请勿重复提交';
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})


// 是否正在刷新中
let isRefreshToken = false

// 响应拦截器
service.interceptors.response.use(async(res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {

      // 如果未认证，并且未进行刷新令牌，说明可能是访问令牌过期了
      if (!isRefreshToken) {
        isRefreshToken = true
        // 1. 如果获取不到刷新令牌，则只能执行登出操作
        if (!getToken()) {
          console.log(' = 如果获取不到刷新令牌，则只能执行登出操作' )
          await router.push({
            path: '/signin'
          })
        }
        // 2. 进行刷新访问令牌
        try {
          const refreshTokenRes = await refreshToken()

          // 2.1 刷新成功，则回放队列的请求 + 当前请求
          setToken( refreshTokenRes.data.data.accessToken)
          setRefreshToken(refreshTokenRes.data.data.refreshToken)
          await router.push({
            path: '/'
          })
        } catch (e) {
          await router.push({
            path: '/signin'
          })
        }
      }

    } else if (code === -699) {
      ElMessage({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    }else if (code === 500) {
      ElMessage({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      ElMessage({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      // Notification.error({ title: msg })

      ElNotification({
        title: 'Error',
        message: msg,
        type: 'error',
      })

      // return Promise.reject('error')
    }else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    // ElMessage({ message: message, type: 'error', duration: 5 * 1000 })

    ElMessage({
      message: message,
      type: 'error',
      duration: 5 * 1000,
      plain: true,
    })


    // return Promise.reject(error)
  }
)

export default service
